<template>
  <label class="hs-textarea" :class="{ 'is-error': error, 'is-disabled': disabled }">
    <span v-if="label" class="hs-textarea__label">{{ label }}<b v-if="required">*</b></span>
    <textarea
      :value="modelValue"
      :placeholder="placeholder"
      :rows="rows"
      :maxlength="maxlength"
      :disabled="disabled"
      @input="$emit('update:modelValue', $event.target.value)"
    />
    <span v-if="hint && !error" class="hs-textarea__hint">{{ hint }}</span>
    <span v-if="error" class="hs-textarea__error">{{ error }}</span>
  </label>
</template>

<script>
export default {
  name: "HsTextarea",
  props: {
    modelValue: { type: String, default: "" },
    label: { type: String, default: "" },
    placeholder: { type: String, default: "" },
    hint: { type: String, default: "" },
    error: { type: String, default: "" },
    rows: { type: [Number, String], default: 4 },
    maxlength: { type: [Number, String], default: null },
    required: { type: Boolean, default: false },
    disabled: { type: Boolean, default: false },
  },
  emits: ["update:modelValue"],
};
</script>

<style scoped>
.hs-textarea {
  display: grid;
  gap: 0.42rem;
}

.hs-textarea__label {
  color: var(--hs-text, #0f172a);
  font-size: 0.82rem;
  font-weight: 950;
}

.hs-textarea__label b,
.hs-textarea__error {
  color: var(--hs-danger, #b91c1c);
}

.hs-textarea textarea {
  background: color-mix(in srgb, var(--hs-bg, #f9fafb) 72%, var(--hs-surface, #ffffff));
  border: 1px solid var(--hs-border, rgba(148, 163, 184, 0.22));
  border-radius: 15px;
  color: var(--hs-text, #0f172a);
  font-size: 0.9rem;
  font-weight: 800;
  line-height: 1.55;
  min-height: 7rem;
  outline: none;
  padding: 0.85rem;
  resize: vertical;
  transition: border-color 0.2s ease, box-shadow 0.2s ease;
}

.hs-textarea textarea:focus {
  border-color: color-mix(in srgb, var(--hs-primary, #3293ec) 46%, var(--hs-border, rgba(148, 163, 184, 0.22)));
  box-shadow: 0 0 0 4px color-mix(in srgb, var(--hs-primary, #3293ec) 11%, transparent);
}

.hs-textarea__hint,
.hs-textarea__error {
  font-size: 0.76rem;
  font-weight: 800;
}

.hs-textarea__hint {
  color: var(--hs-muted, #64748b);
}

.is-error textarea {
  border-color: color-mix(in srgb, var(--hs-danger, #b91c1c) 55%, var(--hs-border, rgba(148, 163, 184, 0.22)));
}

.is-disabled {
  opacity: 0.62;
}
</style>
